export const primary = "#ee2400";
export const lightenPrimary = "#ffefea";
export const secondary = "#e9e9e9";
export const lightenSecondary = "#ededed";
export const white = "#fff";
export const dark = "#151515";
